import React from 'react';
import { notifySalesforceConnection } from '../connectionChannel';

export const SalesforceSuccessResult = () => {
    React.useEffect(() => {
        notifySalesforceConnection(true);
    }, []);

    return (
        <div style={{ padding: '100px 50%' }}>
            <div style={{ textAlign: 'center', width: '350px' }}>
                <i style={{ fontSize: '50px' }} />
                <div style={{ marginTop: '50px' }}>
                    <h4>Salesforce connection succeeded - congratulations!</h4>
                    <button onClick={() => window.close()} className="btn btn-primary" style={{ marginTop: '30px' }}>
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SalesforceSuccessResult;
